import { sendIgnoreRecommendation } from 'src/api/tracker';
import buildReturnUrl from 'src/api/build-return-url';

import { removeOffer } from 'src/redux/actions/offers';

export const ignoreOffer =
  ({ offerId }) =>
  (dispatch, getState) => {
    const {
      configReducer: { loginURL, homepageURL },
      contextReducer: { context },
      credentialsReducer: { mpUserId },
    } = getState();

    if (mpUserId) {
      sendIgnoreRecommendation(offerId, context);

      return dispatch(removeOffer(offerId));
    }

    const returnUrl = buildReturnUrl({
      originUrl: loginURL,
      returnUrl: homepageURL,
    });
    return window.location.assign(returnUrl);
  };

export default {
  ignoreOffer,
};
